import { useEffect, useState } from 'react'

import { API, Storage } from 'aws-amplify'

import { useParams } from 'react-router-dom'
import { getFundraisingCampaignDiscoveryCall } from '../../managers/graphql/queries'
import { FundraisingCampaignDiscoveryCall } from '../../API'
import { Button, CircularProgress, Typography } from '@mui/material'
import AddToCalendar from '@culturehq/add-to-calendar';
import '@culturehq/add-to-calendar/dist/styles.css'

import LogoBlack from './../../assets/logo/logo_black.svg'
import DownloadAppleAppStoreSVG from './../../assets/images/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg'
import AppStoreQRCode from './../../assets/images/app_store_qr_code.png'
import PlayStoreQRCode from './../../assets/images/play_store_qr_code.png'
import RegistrationGIF from './../../assets/animations/latent_mobile_register.gif'

export default function Discovery(props: any) {

    const { id }: any = useParams()

    const [discoveryMeeting, setDiscoveryMeeting] = useState<FundraisingCampaignDiscoveryCall | null>(null)
    const [discoveryMeetingNotFound, setDiscoveryMeetingNotFound] = useState<boolean>(false)

    const [headerImageURI, setHeaderImageURI] = useState<string | null>(null)
    const [logoImageURI, setLogoImageURI] = useState<string | null>(null)

    useEffect(() => {
        (async () => {
            if (id) {
                const { data }: any = await API.graphql({
                    query: `
                    query GetFundraisingCampaignDiscoveryCall($id: ID!) {
                      getFundraisingCampaignDiscoveryCall(id: $id) {
                        id
                        title
                        organizationID
                        fundraisingCampaignID
                        staffProfileID
                        startTimestamp
                        endTimestamp
                        latentHosted
                        invitationURL
                        virtualMeetingURL
                        nylasEventID
                        createdAt
                        updatedAt
                        staffProfile {
                          organizationID
                          role
                          name
                          authAccount {
                            name
                            firstName
                            lastName
                            primaryEmail
                            gender
                            selfDescribedGender
                            communicationsProfile {
                              id
                            }
                          }
                        }
                        organization {
                          id
                          name
                          shortName
                          description
                          website
                          phoneNumber
                          headerImageURI
                          ambassadorTermOverrideSingular
                          ambassadorTermOverridePlural
                          primaryColor
                          secondaryColor
                          createdAt
                          updatedAt
                          location {
                            type
                            name
                            details
                            owner
                            address {
                              streetAddress
                              unit
                              city
                              state
                              zip
                              zipPlusFour
                              longitude
                              latitude
                              createdAt
                              updatedAt
                              owner
                            }
                          }
                        }
                        fundraisingCampaign {
                          id
                          type
                          organizationID
                          staffLeadID
                          campaignName
                          introVideoURI
                          active
                          publicVideoID
                          publicVideoProvider
                          campaignEndDate
                          publicCampaignAbout
                          publicCampaignIntro
                          campaignGoal
                          pageLayout
                          primaryColor
                          secondaryColor
                          buttonBackgroundColor
                          buttonTextColor
                          customHeaderImageUploaded
                          customLogoImageUploaded
                          headerFont
                          bodyFont
                          onDemandDiscoveryMeetingEnabled
                          onDemandDiscoveryMeetingURL
                          onDemandDiscoveryMeetingID
                          onDemandDiscoveryMeetingInvitationCode
                          staffLead {
                            id
                            role
                            name
                            authAccount {
                              communicationsProfileID
                              name
                              firstName
                              lastName
                              primaryEmail
                              bio
                            }
                          }
                        }
                      }
                    }
                  `,
                    variables: {
                        id: id
                    },
                    authMode: 'AWS_IAM'
                })
                console.log(data)
                if (data.getFundraisingCampaignDiscoveryCall == null) {
                    setDiscoveryMeetingNotFound(true)
                } else if (data.getFundraisingCampaignDiscoveryCall) {
                    setDiscoveryMeeting(data.getFundraisingCampaignDiscoveryCall)
                }
                if (data && data.getFundraisingCampaignDiscoveryCall) {
                    console.log(new Date(data.getFundraisingCampaignDiscoveryCall.startTimestamp).getTime())
                    console.log(new Date().getTime())
                    console.log(new Date(data.getFundraisingCampaignDiscoveryCall.startTimestamp).getTime() - new Date().getTime() / 1000 / 60 / 60)

                    const _fundraisingCampaign = data.getFundraisingCampaignDiscoveryCall.fundraisingCampaign

                    console.log(_fundraisingCampaign)

                    if (_fundraisingCampaign.customHeaderImageUploaded) {
                        const uri = await Storage.get(`campaigns/${_fundraisingCampaign.id}/headerImage`, { level: 'public' })
                        setHeaderImageURI(uri)
                    } else {
                        const uri = await Storage.get(`organizations/${_fundraisingCampaign.organizationID}/headerImage`, { level: 'public' })
                        setHeaderImageURI(uri)
                    }
                    if (_fundraisingCampaign.customLogoImageUploaded) {
                        const uri = await Storage.get(`campaigns/${_fundraisingCampaign.id}/logoImage`, { level: 'public' })
                        setLogoImageURI(uri)
                    } else {
                        const uri = await Storage.get(`organizations/${_fundraisingCampaign.organizationID}/profilePicture`, { level: 'public' })
                        setLogoImageURI(uri)
                    }
                }
            }
        })()
    }, [id])

    if (discoveryMeeting) {
        return (
            <div className="bg-light" style={{ minHeight: '100vh', width: '100%' }}>
                <div className="container-fluid g-0" style={{ zIndex: -1 }}>
                    <div className="row g-0">
                        <div className="col-12">
                            <div className="d-flex flex-column justify-content-center align-items-center bg-white">
                                <img src={headerImageURI ? headerImageURI : ''} style={{ width: '100%', height: 500, objectFit: 'cover', opacity: 0.25 }} className="bg-white" />
                                <div className="w-100 row" style={{ position: 'absolute' }}>
                                    <div className="col-12 d-flex flex-row justify-content-center align-items-center">
                                        <img src={logoImageURI ? logoImageURI : ''} style={{ width: 300, height: 250, objectFit: 'contain' }} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container" style={{ bottom: 50, zIndex: 2, opacity: 1, position: 'relative' }}>
                    <div className="row">
                        <div className="w-100 col-12 d-flex flex-row justify-content-center align-items-center">
                            <div className=" w-100 row p-5 bg-white rounded shadow">
                                <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-start">
                                    <Typography variant="h2">{discoveryMeeting.title ? discoveryMeeting.title : 'Discovery Meeting'}</Typography>
                                    {
                                        discoveryMeeting.id != discoveryMeeting.fundraisingCampaign?.onDemandDiscoveryMeetingID ?
                                            <Typography variant="h4">{new Date(discoveryMeeting.startTimestamp).toLocaleDateString()}</Typography>
                                            :
                                            <div />
                                    }
                                    <Typography variant="body1">{discoveryMeeting.id != discoveryMeeting.fundraisingCampaign?.onDemandDiscoveryMeetingID ? `${new Date(discoveryMeeting.startTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })} to ${new Date(discoveryMeeting.endTimestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', timeZoneName: 'short' })}` : 'On Demand Option'}</Typography>
                                </div>
                                <div className="col-12 col-lg-6 d-flex flex-column justify-content-center align-items-center align-items-lg-end">
                                    {
                                        discoveryMeeting.id != discoveryMeeting.fundraisingCampaign?.onDemandDiscoveryMeetingID ?
                                            <AddToCalendar event={{
                                                name: discoveryMeeting.title ? discoveryMeeting.title : 'Discovery Meeting',
                                                details: `Join the virtual meeting using this link: ${discoveryMeeting.virtualMeetingURL}`,
                                                location: discoveryMeeting.virtualMeetingURL ? discoveryMeeting.virtualMeetingURL : 'Virtual',
                                                startsAt: discoveryMeeting.startTimestamp,
                                                endsAt: discoveryMeeting.endTimestamp,
                                                
                                            }} filename={`${discoveryMeeting.title ? discoveryMeeting.title : 'Discovery Meeting'} Invitation`} />
                                            :
                                            <a href={discoveryMeeting.fundraisingCampaign.onDemandDiscoveryMeetingURL ? discoveryMeeting.fundraisingCampaign.onDemandDiscoveryMeetingURL : ''} target="_blank" style={{ textDecoration: 'none' }}>
                                                <Button variant="outlined">
                                                    View On Demand Meeting
                                                </Button>
                                            </a>
                                    }
                                    {
                                        (new Date(discoveryMeeting.startTimestamp).getTime() - new Date().getTime()) / 1000 / 60 / 60 <= 24 && discoveryMeeting.virtualMeetingURL ?
                                            <a href={discoveryMeeting.virtualMeetingURL} style={{ textDecoration: 'none' }} target="_blank"><Button variant="contained">Join Meeting</Button></a>
                                            :
                                            <div />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-12 mt-5">
                            <Typography variant="h1">Next Steps</Typography>
                            <Typography variant="body1">Before the Discovery Meeting, we'll need you to complete a couple steps.</Typography>
                            <Typography variant="h3" className="mt-5">Download the app</Typography>
                            <Typography variant="body1">The Latent app will help provide an interactive experience during the Discovery Meeting.</Typography>
                            <div className="row">
                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-center">
                                    <div className="m-5 border rounded p-3 pt-5 d-flex flex-column justify-content-center align-items-center w-100">
                                        <Typography variant="h5">iPhone user?</Typography>
                                        <Typography variant="caption">Click the button or scan the QR code below.</Typography>
                                        <a href="https://apps.apple.com/us/app/latent/id1618551569" target="_blank"><img src={DownloadAppleAppStoreSVG} style={{ objectFit: 'contain', width: 200, height: 100 }} /></a>
                                        <img src={AppStoreQRCode} style={{ width: 200, height: 200, objectFit: 'contain' }} className="mb-5" />
                                    </div>
                                </div>
                                <div className="col-12 col-lg-6 d-flex flex-row justify-content-center">
                                    <div className="m-5 border rounded p-3 pt-5 d-flex flex-column justify-content-center align-items-center w-100">
                                        <Typography variant="h5">Android user?</Typography>
                                        <Typography variant="caption">Click the button or scan the QR code below.</Typography>
                                        <a href='https://play.google.com/store/apps/details?id=com.flourish.latentmobile&hl=en_US&gl=US&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1' target="_blank"><img alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png' style={{ objectFit: 'contain', width: 250, height: 100 }} /></a>
                                        <img src={PlayStoreQRCode} style={{ width: 200, height: 200, objectFit: 'contain' }} className="mb-5" />
                                    </div>
                                </div>
                            </div>
                            <Typography variant="h3" className="mt-5">Create your account</Typography>
                            <Typography variant="body1">Having an account before the meeting starts will allow you to explore the app during the meeting.</Typography>
                            <div className="col-12 d-flex flex-row justify-content-center">
                                <div className="row border rounded p-5 m-5 w-100">
                                    <div className="col-12 col-lg-4">
                                        <div className="d-none d-lg-flex flex-column justify-content-center align-items-end w-100" style={{ textAlign: 'right' }}>
                                            <Typography variant="h5">1. Add your phone number</Typography>
                                            <Typography variant="body1">Include your three digit area code at the beginning</Typography>
                                            <Typography variant="h5"><br /><br /></Typography>
                                            <Typography variant="body1"><br /><br /><br /></Typography>
                                            <Typography variant="h5">3. Add a password</Typography>
                                            <Typography variant="body1">Your password should be at least eight characters long</Typography>
                                            <Typography variant="h5"><br /><br /></Typography>
                                            <Typography variant="body1"><br /><br /><br /><br /></Typography>
                                            <Typography variant="h5">5. Add a name</Typography>
                                            <Typography variant="body1">Once registered you'll be prompted to add a name and profile picture</Typography>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4 h-auto">
                                        <div className="d-flex flex-row justify-content-center align-items-center w-100 ">
                                            <img src={RegistrationGIF} style={{ width: 350, height: 500, objectFit: 'contain' }} />
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-4">
                                        <div className="d-none d-lg-flex flex-column justify-content-center align-items-start w-100" style={{ textAlign: 'left' }}>
                                            <Typography variant="h5"><br /><br /></Typography>
                                            <Typography variant="body1"><br /><br /><br /><br /></Typography>
                                            <Typography variant="h5">2. Add your email address</Typography>
                                            <Typography variant="body1">This can be a personal or work email address</Typography>
                                            <Typography variant="h5"><br /><br /></Typography>
                                            <Typography variant="body1"><br /><br /><br /><br /></Typography>
                                            <Typography variant="h5">4. Verify your phone number</Typography>
                                            <Typography variant="body1">You'll recieve a text message with a six digit verification code</Typography>
                                        </div>
                                    </div>
                                    <div className="col-12 col-lg-0">
                                        <div className="d-flex d-lg-none flex-column justify-content-center align-items-start w-100">
                                            <Typography variant="h5" className="mt-3">Add your phone number</Typography>
                                            <Typography variant="body1">Include your three digit area code at the beginning</Typography>
                                            <Typography variant="h5" className="mt-3">Add your email address</Typography>
                                            <Typography variant="body1">This can be a personal or work email address</Typography>
                                            <Typography variant="h5" className="mt-3">Add a password</Typography>
                                            <Typography variant="body1">Your password should be at least eight characters long</Typography>
                                            <Typography variant="h5" className="mt-3">Verify your phone number</Typography>
                                            <Typography variant="body1">You'll recieve a text message with a six digit verification code</Typography>
                                            <Typography variant="h5" className="mt-3">Add a name</Typography>
                                            <Typography variant="body1">Once registered you'll be prompted to add a name and profile picture</Typography>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {
                                discoveryMeeting.fundraisingCampaign?.onDemandDiscoveryMeetingInvitationCode ?
                                    <div>
                                        <Typography variant="h3" className="mt-5">Enter invitation code</Typography>
                                        <Typography variant="body1">To get started, you'll need to enter this invitation code.</Typography>
                                        <div className="col-12 d-flex flex-row justify-content-center">
                                            <div className="border rounded p-5 m-5 w-100 d-flex flex-row justify-content-center align-items-center">
                                                <Typography variant="h2">{discoveryMeeting.fundraisingCampaign.onDemandDiscoveryMeetingInvitationCode}</Typography>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div />
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    } else if (discoveryMeeting == null && discoveryMeetingNotFound) {
        return (
            <div className="container w-100" style={{ minHeight: '100vh' }}>
                <div className="row">
                    <div className="col-12 w-100 h-100 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                        <img src={LogoBlack} className="mb-3" style={{ width: 50, height: 50, objectFit: 'contain' }} />
                        <Typography variant="h2">Not Found</Typography>
                        <Typography variant="body1">We couldn't find the Discovery Meeting you requested. Contact support or try again.</Typography>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="container w-100 h-100">
                <div className="row">
                    <div className="col-12 w-100 h-100 d-flex flex-column justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                        <CircularProgress />
                    </div>
                </div>
            </div>
        )
    }
}